/**
 * What a cap by category consistency has to say for itself
 * (CU-869ffwfb0).
 *
 * The node used to read "Category consistency · 170.00 € → 160.09 €"
 * and stop there, leaving the operator to go and look up which car
 * blocked the bid and at what price — which the engine had recorded all
 * along in the cap's `source` (`reference_acriss`, `reference_price`,
 * `value_code`, `group_name`). Thibault asked for it in his own words
 * (2026-10-12): "MDMR 7 días = 160.09 … MBMR no puede superar MDMR".
 */

//: Mirrored from `Activity/index.jsx`, like `incompleteMarket.js` does
//: and for the same reason: importing them would make the screen and
//: its copy circular.
const eur = (n) => (n == null ? '—' : `${Number(n).toFixed(2)} €`)
const totalOf = (daily, days) =>
	(daily == null ? null : (Number(days) > 0 ? Number(daily) * Number(days) : Number(daily)))

/**
 * `["MBMR cannot exceed MDMR · MDMR is at 179.34 € (25.62 €/day)",
 *   'group "Manual"']` — the rental total first, because that is what
 * the rest of the rail shows, with the daily figure beside it.
 */
export function consistencyNotes(cap, days) {
	const src = cap?.source || {}
	const out = []
	const ref = src.reference_acriss
	const price = src.reference_price
	if (ref) {
		const at = price == null ? ''
			: Number(days) > 1
				? ` · ${ref} is at ${eur(totalOf(price, days))} (${eur(price)}/day)`
				: ` · ${ref} is at ${eur(price)}`
		out.push(`${src.value_code || 'this car'} cannot exceed ${ref}${at}`)
	}
	if (src.group_name) out.push(`group "${src.group_name}"`)
	return out
}
